import { render, staticRenderFns } from "./OpenFundraisingNeeds.vue?vue&type=template&id=5ca38ad2&scoped=true"
import script from "./OpenFundraisingNeeds.vue?vue&type=script&lang=js"
export * from "./OpenFundraisingNeeds.vue?vue&type=script&lang=js"
import style0 from "./OpenFundraisingNeeds.vue?vue&type=style&index=0&id=5ca38ad2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca38ad2",
  null
  
)

export default component.exports